"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useIntl } from "@amazeelabs/react-intl-rsc";
import { Dialog, Disclosure, Transition } from "@headlessui/react";
import clsx from "clsx";
import { motion } from "framer-motion";
import React, { createContext, Fragment } from "react";
import { DropdownIcon } from "../Molecules/icons";
export var MobileMenuContext = /*#__PURE__*/ createContext({
    isOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setIsOpen: function(isOpen) {}
});
export function MobileMenuProvider(param) {
    var children = param.children;
    var _React_useState = _sliced_to_array(React.useState(false), 2), isOpen = _React_useState[0], setIsOpen = _React_useState[1];
    return /*#__PURE__*/ React.createElement(MobileMenuContext.Provider, {
        value: {
            isOpen: isOpen,
            setIsOpen: setIsOpen
        }
    }, children);
}
export function MobileMenuButton() {
    var intl = useIntl();
    var _React_useContext = React.useContext(MobileMenuContext), isOpen = _React_useContext.isOpen, setIsOpen = _React_useContext.setIsOpen;
    return /*#__PURE__*/ React.createElement(motion.button, {
        onClick: function() {
            return setIsOpen(!isOpen);
        },
        initial: "closed",
        animate: isOpen ? "open" : "closed",
        exit: "open",
        className: !isOpen ? "focus-dark" : "focus-white"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "{action} main navigation",
        id: "BpZi73"
    }, {
        action: isOpen ? "Close" : "Open"
    })), /*#__PURE__*/ React.createElement("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33"
    }, /*#__PURE__*/ React.createElement(motion.path, {
        strokeWidth: 3,
        strokeLinecap: "round",
        variants: {
            closed: {
                d: "M 30 2.5 L 8 2.5",
                stroke: "#004F40"
            },
            open: {
                d: "M 3 30 L 30 2.5",
                stroke: "#FFF"
            }
        }
    }), /*#__PURE__*/ React.createElement(motion.path, {
        strokeWidth: 3,
        strokeLinecap: "round",
        variants: {
            closed: {
                d: "M 30 16 L 14 16",
                stroke: "#004F40",
                strokeWidth: 3
            },
            open: {
                d: "M 0 9.423 L 0 9.423",
                strokeWidth: 0
            }
        }
    }), /*#__PURE__*/ React.createElement(motion.path, {
        strokeWidth: 3,
        strokeLinecap: "round",
        variants: {
            closed: {
                d: "M 2 30 L 30 30",
                stroke: "#004F40"
            },
            open: {
                d: "M 3 2.5 L 30 30",
                stroke: "#FFF"
            }
        }
    })));
}
export function MobileMenu(param) {
    var children = param.children;
    var _React_useContext = React.useContext(MobileMenuContext), isOpen = _React_useContext.isOpen, setIsOpen = _React_useContext.setIsOpen;
    return /*#__PURE__*/ React.createElement(Transition, {
        show: isOpen,
        as: Fragment
    }, /*#__PURE__*/ React.createElement(Dialog, {
        as: "div",
        className: "lg:hidden",
        onClose: setIsOpen
    }, /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 z-10"
    }), /*#__PURE__*/ React.createElement(Transition.Child, {
        enter: "transition ease-out duration-200",
        enterFrom: "opacity-0 translate-x-10",
        enterTo: "opacity-100 translate-x-0",
        leave: "transition ease-in duration-150",
        leaveFrom: "opacity-100 translate-y-0",
        leaveTo: "opacity-0 translate-x-10",
        as: Fragment
    }, /*#__PURE__*/ React.createElement(Dialog.Panel, {
        className: "w-full fixed inset-y-0 right-0 z-10  overflow-y-auto bg-green-500 sm:ring-1 sm:ring-gray-900/10 container-page"
    }, children))));
}
export function MobileMenuLink(param) {
    var title = param.title, href = param.href;
    return /*#__PURE__*/ React.createElement(Disclosure.Button, {
        as: "a",
        href: href,
        className: "text-lg leading-lg font-normal text-white p-1 hover:bg-black/20 focus-white"
    }, title);
}
export function MobileMenuDropdown(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ React.createElement(Disclosure, {
        as: "div"
    }, function(param) {
        var open = param.open;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Disclosure.Button, {
            className: clsx("flex flex-row w-screen items-center justify-between py-3 text-lg leading-lg text-white focus:bg-white/20 transition-all ease-in-out duration-300 -mx-[1.25rem] px-[1.25rem] hover:bg-white/20 focus-white", {
                "bg-white/20": open
            })
        }, title, /*#__PURE__*/ React.createElement(DropdownIcon, {
            isOpen: open
        }))), /*#__PURE__*/ React.createElement(Transition, {
            show: open,
            className: "overflow-hidden",
            enter: "transition-all duration-300 ease-in",
            enterFrom: "transform max-h-0 opacity-0",
            enterTo: "transform max-h-screen opacity-100",
            leave: "transition-all duration-300 ease-out",
            leaveFrom: "transform max-h-screen opacity-100",
            leaveTo: "transform max-h-0 opacity-0"
        }, /*#__PURE__*/ React.createElement(Disclosure.Panel, {
            className: "space-y-1 border-b-[1px] border-white/20 pt-4 pb-6 mb-3 flex flex-col gap-4 pl-5 pr-2",
            as: "ul"
        }, children)));
    });
}
